import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { SESSION_STORAGE_KEYS } from 'common/constants/constants';
import { redirectToProvider } from 'common/utils/utils';

export const redirectToMsTeams = (team, appVersion) => {
  if (team && team.id) {
    BrowserStorageAccessor().session.set(
      SESSION_STORAGE_KEYS.MSTEAMS_REDIRECT_TEAM_ID,
      team.id
    );
  }

  const queryParams = {
    isOrgSettings: true,
    ...(window.location.search.includes('isE2eTestFlow')
      ? { isE2eTestFlow: 1 }
      : {})
  };

  redirectToProvider(appVersion, {
    redirectPath: 'settings/msteams',
    query: queryParams
  });
};
